/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCertification = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a6 6 0 0 1 4.001 10.471L16 21.87l-4-2.667-4 2.667v-9.397A6 6 0 0 1 12 2zm2.001 11.658A5.975 5.975 0 0 1 12 14l.306-.008a6.1 6.1 0 0 1-.612 0l-.039-.002A5.963 5.963 0 0 1 10 13.658v4.472l2-1.332 2 1.333zM12 4a4 4 0 0 0-2.69 6.961l.292.219a3.982 3.982 0 0 0 2.151.813L12 12a3.88 3.88 0 0 0 .278-.01l-.031.002a3.98 3.98 0 0 0 2.15-.812l.291-.218A4 4 0 0 0 12 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCertification as Certification };
